import React from "react";
import { Box, Typography, Grid, Card, CardContent } from "@mui/material";
import { LocationOn, Laptop, MoveToInbox } from "@mui/icons-material";

const commitments = [
  {
    src: "sm-logo1.png" ,// Blue icon
    title: "Transparent Quotes",
    description:
      "We provide you with a realistic estimate based on market conditions, so there are no unexpected surprises."
  },
  {
    src: "sm-logo2.png" , // Blue icon
    title: "No Unethical Practices",
    description:
      "We won’t artificially inflate prices or threaten customers with hefty cancellation fees."
  },
  {
    src: "sm-logo3.png" , // Blue icon
    title: "Quality Service",
    description:
      "Our network of vetted dispatchers and truck drivers ensures your vehicle’s safe and timely delivery."
  }
];

const CommitmentSection = () => {
  return (
    <Box sx={{ textAlign: "center", p: 5, backgroundColor: "#fff" }}>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: "bold", color: "#333", letterSpacing: 1 }}
      >
        BECAUSE YOUR PEACE OF MIND MATTERS.
      </Typography>
      <Typography
        variant="h4"
        sx={{ fontWeight: "bold", color: "#000", mt: 1, mb: 4, fontFamily:"'Black Ops One',sans-serif", }}
      >
        We Commit to
      </Typography>
      <Grid container spacing={4} justifyContent="center">
        {commitments.map((commitment, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Card
              // elevation={commitment.title === "Quality Service" ? 3 : 0} // Subtle highlight on last card
              sx={{
                textAlign: "center",
                p: 3,
                height: "100%",
                borderRadius: 2,
                transition: "0.3s",
                backgroundColor:  "transparent"
              }}
            >
              <CardContent>
                <img src={commitment.src} style={{width:'120px',height:'120px'}} alt="logo"/>
                <Typography variant="h6" sx={{ fontWeight: "bold", mt: 2 }}>
                  {commitment.title}
                </Typography>
                <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
                  {commitment.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CommitmentSection;